(() => {
  if (customElements.get('fk-discount-progress')) return;
  const instances = new Set();
  let latestCart;
  let inFlight = false;
  let revision = 0;
  let timer;
  const money = new Intl.NumberFormat('en-IN', { style: 'currency', currency: 'INR', maximumFractionDigits: 2, minimumFractionDigits: 0 });
  const eligibleTotal = cart => cart.items.reduce((sum, item) => sum + (item.gift_card ? 0 : Number(item.original_line_price) || 0), 0);
  function render(element, cart) {
    element.hidden = cart.currency !== 'INR';
    if (element.hidden) return;
    const total = eligibleTotal(cart);
    const progress = Math.min(100, Math.max(0, total / 2000));
    const template = total >= 200000 ? element.dataset.complete : total >= 100000 ? element.dataset.next : element.dataset.first;
    const remaining = Math.max(0, (total >= 100000 ? 200000 : 100000) - total);
    const message = template.replace('__AMOUNT__', money.format(remaining / 100));
    const label = element.querySelector('.fkdp__message');
    if (label.textContent.trim() !== message) label.textContent = message;
    const track = element.querySelector('.fkdp__track');
    track.setAttribute('aria-valuenow', String(Math.round(progress)));
    track.setAttribute('aria-valuetext', message);
    element.querySelector('.fkdp__fill').style.width = `${progress}%`;
    element.querySelectorAll('[data-tier]').forEach(tier => tier.classList.toggle('is-unlocked', total >= Number(tier.dataset.tier)));
  }
  async function refresh() {
    if (inFlight || !instances.size) return;
    inFlight = true;
    const requestedRevision = revision;
    try {
      const root = window.Shopify?.routes?.root || '/';
      const response = await fetch(`${root}cart.js`, { headers: { Accept: 'application/json' }, cache: 'no-store' });
      if (!response.ok) return;
      const cart = await response.json();
      if (requestedRevision === revision && Array.isArray(cart.items)) {
        latestCart = cart;
        instances.forEach(element => render(element, cart));
      }
    } catch {} finally {
      inFlight = false;
      if (requestedRevision !== revision) schedule();
    }
  }
  function schedule() {
    clearTimeout(timer);
    timer = setTimeout(refresh, 0);
  }
  function changed() {
    revision += 1;
    schedule();
  }
  customElements.define('fk-discount-progress', class extends HTMLElement {
    connectedCallback() {
      instances.add(this);
      if (latestCart) render(this, latestCart);
      schedule();
    }
    disconnectedCallback() { instances.delete(this); }
  });
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') subscribe(PUB_SUB_EVENTS.cartUpdate, changed);
  ['cart:updated', 'cart:refresh', 'cart:change', 'cart:added', 'shopify:section:load'].forEach(name => document.addEventListener(name, changed));
  if (typeof PerformanceObserver !== 'undefined') {
    try {
      const observer = new PerformanceObserver(list => {
        if (list.getEntries().some(entry => {
          const url = new URL(entry.name, location.href);
          return url.origin === location.origin && /\/cart\/(add|change|update|clear)(\.js|\.json)?\/?$/.test(url.pathname);
        })) changed();
      });
      observer.observe({ type: 'resource' });
    } catch {}
  }
  window.addEventListener('pageshow', changed);
  document.addEventListener('visibilitychange', () => { if (!document.hidden) changed(); });
})();
